import { render, staticRenderFns } from "./related-prompts-pill.component.vue?vue&type=template&id=63fdd9eb&scoped=true"
import script from "./related-prompts-pill.component.vue?vue&type=script&lang=ts"
export * from "./related-prompts-pill.component.vue?vue&type=script&lang=ts"
import style0 from "./related-prompts-pill.component.vue?vue&type=style&index=0&id=63fdd9eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fdd9eb",
  null
  
)

export default component.exports